import React, { useEffect, useState } from "react";

import AddPersonalDetailsForm from "../../../components/AddPersonalDetailsForm/AddPersonalDetailsForm";
import { Box } from "@mui/material";
import ChooseLocationForm from "../../../components/ChooseLocationForm/ChooseLocationForm";
import { IRootState } from "../../../state";
import { LayoutOnboarding } from "../../../components";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { useLocation } from "react-router-dom";
import { useProfileCreateV2 } from "../../../services/user-create-v2/user-create.service";
import { useSelector } from "react-redux";
import { useUserCreateStore } from "../../../hooks/redux-hooks/user-create-store/user-create.store";
import { userActivityLogger } from "../../../utils/mixpanel";

const ProfileCompletionContainer = () => {
  const { user } = useSelector((state: IRootState) => state.user);

  const { setCreateProfile, createProfile: profile } = useUserCreateStore();
  const { createProfile, data, error } = useProfileCreateV2();

  const [msa, setMsa] = useState<string>("");
  const [activeStep, setActiveStep] = useState(0);
  const [selectedLocationName, setSelectedLocationName] = useState<string>("");
  const location = useLocation();
  // When reached via Landing/Dashboard (existing authenticated user with no
  // completed profile), navigation state carries no phone. Fall back to the
  // user's existing phone so we never submit an empty phone, which the backend
  // rejects (@IsNotEmpty on ProfileUpdateInputV2.phone).
  const phone = location.state?.phone || user?.phone || user?.fireBasePhone || "";
  const onSubmitStep1 = (data: any) => {
    data.phone = phone;
    setCreateProfile(data);
    setTimeout(() => {
      userActivityLogger(MIXPANEL_EVENTS.USER_FILL_PERSONAL_DETAILS, {});
    }, 600);
    setActiveStep(1);
  };

  useEffect(() => {
    if (error) {
      userActivityLogger(MIXPANEL_EVENTS.USER_SIGNUP_FAILURE, {
        location: selectedLocationName,
        msa: msa,
        error_message: error.graphQLErrors[0]?.message,
      });
    }
    if (data) {
      userActivityLogger(MIXPANEL_EVENTS.USER_SIGNUP_SUCCESS, {
        location: selectedLocationName,
        msa: msa,
      });
    }
  }, [data, error]);

  const onSubmit = (data:any) => {
    setCreateProfile({ ...profile, ...data });
    userActivityLogger(MIXPANEL_EVENTS.USER_CHOOSE_LOCATION, {
      location: selectedLocationName,
      msa: msa,
    });
    createProfile({ ...profile, ...data });
  };

  return (
    <LayoutOnboarding image="/assets/icons/ftue.png">
      <Box className="bg-gray-2 flex flex-col h-full gap-4 overflow-y-scroll scroll-hide">
        <Box className="mb-4">
          <Box className="">
            {activeStep === 0 ? (
              <Box className="flex flex-col items-center justify-center gap-2">
                <Box className="text-3xl font-bold">
                  Let&apos;s Create Your Profile
                </Box>
                <Box className="text-base">
                  Enter your first and last name to begin.
                </Box>
              </Box>
            ) : (
              <Box className="flex flex-col items-center justify-center gap-2">
                <Box className="text-3xl font-bold">
                  Choose Your Home Hospital
                </Box>
                <Box className="text-base">
                  Enter your address to see the hospitals in your area.
                </Box>
              </Box>
            )}
          </Box>
        </Box>
        <Box className="flex overflow-y-auto scroll-hide h-full grow pb-[20%]">
          {activeStep === 0 ? (
            <AddPersonalDetailsForm onSubmitStep1={onSubmitStep1} personalDetails={profile} />
          ) : (
            <ChooseLocationForm onSubmit={onSubmit} setMsa={setMsa} setSelectedLocationName={setSelectedLocationName} />
          )}
        </Box>
      </Box>
    </LayoutOnboarding>
  );
};

export default ProfileCompletionContainer;
